import { canUseDOM } from '../../components';

export const FETCH_HOME_CLIENT = 'FETCH_HOME_CLIENT';
export const FETCH_HOME = 'FETCH_HOME';
export const FETCH_HOME_START = 'FETCH_HOME_START';
export const FETCH_HOME_SUCCESS = 'FETCH_HOME_SUCCESS';
export const FETCH_HOME_ERROR = 'FETCH_HOME_ERROR';

export const FETCH_AVAILABLE_RESULTS = 'FETCH_AVAILABLE_RESULTS';
export const FETCH_AVAILABLE_RESULTS_START = 'FETCH_AVAILABLE_RESULTS_START';
export const FETCH_AVAILABLE_RESULTS_SUCCESS = 'FETCH_AVAILABLE_RESULTS_SUCCESS';
export const FETCH_AVAILABLE_RESULTS_ERROR = 'FETCH_AVAILABLE_RESULTS_ERROR';

const fetchFn = (fetch, url, verb, params) => fetch(url, {
  method: verb,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Connection: 'keep-alive',
  },
  body: JSON.stringify(params),
  credentials: 'same-origin',
});

export function fetchHome(params) {
  if (canUseDOM) {
    return () => ({
      type: FETCH_HOME_CLIENT,
    });
  }
  const url = '/portal-srp/api/v1/home';
  const verb = 'POST';
  const body = {
    site: params.apireq.site,
    domain: params.domain,
    locale: params.locale,
    apireq: params.apireq,
    baseUri: params.uri,
    queryFilters: params.queryFilters,
    // TECH-9753: the SSR fetch forwards no cookies, the smartsearch flag travels in the body
    ...(params.useSmartSearch ? { useSmartSearch: true } : {}),
  };
  return ({ fetch }) => ({
    type: FETCH_HOME,
    payload: {
      promise: fetchFn(fetch, url, verb, body)
        .then((response) => response.json())
        .then((data) => ({ ...data, queryFilters: params.queryFilters }))
        .catch((err) => console.error('error', err)),
    },
  });
}

const fetchAvailableResultsFn = (fetch, verb, params) => fetch('/portal-srp/api/v1/home/availableresults', {
  method: verb,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Connection: 'keep-alive',
  },
  body: JSON.stringify(params),
  credentials: 'same-origin',
});

export function fetchAvailableResults(params) {
  return ({ fetch }) => ({
    type: FETCH_AVAILABLE_RESULTS,
    payload: {
      search: 'something',
      promise: fetchAvailableResultsFn(fetch, 'POST', params)
        .then(response => response.json())
        .catch(err => console.log('error', err)),
    },
  });
}
